import { render, staticRenderFns } from "./Upgrades.vue?vue&type=template&id=065758e6"
import script from "./Upgrades.vue?vue&type=script&lang=js"
export * from "./Upgrades.vue?vue&type=script&lang=js"
import style0 from "./Upgrades.scss?vue&type=style&index=0&prod&lang=scss&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports